export function FAQ() {
  return (
    <>
      <h1>FAQ</h1>
      <p>This is the FAQ page, nothing to see here yet...</p>
    </>
  );
}
